import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppSelector } from "../../../../store/hooks";

import { Image } from "antd";
import { selectStickerEntities, selectStickerIds } from "../../../../store/sticker_maker/stickersSlice";

import Card from "./_Card";

const _ListGrid = () => {
  const ids       = useAppSelector(selectStickerIds);
  const stickers  = useAppSelector(selectStickerEntities);

  const renderSticker = (id: EntityId) => {
    const sticker = stickers[id];

    if (!sticker) {
      return;
    }

    return <Card sticker={sticker} key={`sticker-${id}`} />;
  }

  return (
    <>
      <Image.PreviewGroup>
        {ids && ids.map(renderSticker)}
      </Image.PreviewGroup>
    </>
  );
}

export default _ListGrid;
